import { useDispatch, useSelector } from 'react-redux';
import Text from '../../../../atoms/Text';
import Badge from '../../../../molecules/Badge';
import Button from '../../../../molecules/Button';
import ExchangeSelector from './ExchangeSelector';
import { IStore } from '../../../../reducers';
import { ECEXExchangeName, ECEXState } from '../../../../reducers/cex_trading';
import { actionRevokeKeyCEXRequest } from '../../../../actions/cex_trading';
import { EXCHANGE_MAPPING } from './ExchangeSelector/helpers';

interface IApiListProps {
  exchange: ECEXExchangeName;
  triggerConnecting?(): void;
}

/**
 * Revoke CEX key btn
 */
const ApiList = ({ exchange, triggerConnecting }: IApiListProps) => {
  const dispatch = useDispatch();

  const state = useSelector((state: IStore) => state.cex_trading.state);

  const onRevoke = () => dispatch(actionRevokeKeyCEXRequest(exchange));

  return (
    <div className='cex_wallet select_wallet__appear_box'>
      <div className='cex_wallet__api_list'>
        <div className='cex_wallet__api_list__title'>
          <Text size={12} className='text--grey-400 text--weight-500'>
            List of APIs
          </Text>
        </div>
        <ExchangeSelector />
        <div className='cex_wallet__api_list__exchange cex_wallet__api_list__exchange--in_progress'>
          <div className='cex_wallet__api_list__exchange__info'>
            <div className='cex_wallet__api_list__exchange__progress icon-protected' />
            <Text size={14}>Other Api</Text>
          </div>
          <Badge variant='fill' klass='orange' text='In Progress' />
        </div>
      </div>
      {triggerConnecting ? (
        <div className='cex_wallet__connect__btn'>
          <Button
            text={`Enter ${EXCHANGE_MAPPING[exchange].label} API Key`}
            action={triggerConnecting}
            size='s'
            variant='primary'
          />
        </div>
      ) : (
        <div className='cex_wallet__connect__btn'>
          <Button
            text='Revoke API key'
            action={onRevoke}
            size='s'
            variant='secondary'
            loading={state === ECEXState.loading}
          />
        </div>
      )}
    </div>
  );
};

export default ApiList;
